module.exports = __webpack_public_path__ + "img/android正式.5bfadd1f.png";